import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.js";
import "./styles.css";
import "./public-service.css";

const root = document.getElementById("root");
if (root === null) throw new Error("Application root was not found");
createRoot(root).render(<StrictMode><App /></StrictMode>);
